
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTop from '../../components/feature/ScrollToTop';

export default function About() {
  const timeline = [
    {
      year: '2016',
      title: 'تأسيس الشركة',
      description: 'بدأت رحلتنا بحلم كبير وفريق صغير من المبدعين المتحمسين لصناعة المحتوى الإعلامي المتميز'
    },
    {
      year: '2018',
      title: 'التوسع والنمو',
      description: 'توسعنا في الخدمات وأضفنا استوديوهات جديدة مجهزة بأحدث التقنيات العالمية'
    },
    {
      year: '2020',
      title: 'الريادة المحلية',
      description: 'أصبحنا من الشركات الرائدة في مجال الإنتاج الإعلامي في المملكة العربية السعودية'
    },
    {
      year: '2022',
      title: 'التوسع الإقليمي',
      description: 'بدأنا العمل مع عملاء من دول الخليج العربي وتوسعنا في الأسواق الإقليمية'
    },
    {
      year: '2024',
      title: 'الابتكار والتطوير',
      description: 'نواصل الابتكار وتطوير خدماتنا لنواكب أحدث التقنيات في عالم الإنتاج الإعلامي'
    }
  ];

  const team = [
    {
      name: 'أحمد محمد الأحمد',
      position: 'المدير التنفيذي والمؤسس',
      image: 'https://public.readdy.ai/ai/img_res/1d60a941479ecdcc0a66959387ed4590.jpg',
      bio: 'خبرة تزيد عن 15 عاماً في مجال الإنتاج الإعلامي والإخراج التلفزيوني'
    },
    {
      name: 'فاطمة عبدالله السالم',
      position: 'مديرة الإنتاج الإبداعي',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Saudi%20Arabian%20female%20creative%20director%20in%20modern%20business%20attire%2C%20confident%20and%20inspiring%20pose%2C%20creative%20studio%20background%20with%20media%20equipment%20and%20artistic%20elements&width=300&height=400&seq=7&orientation=portrait',
      bio: 'متخصصة في الإنتاج الإبداعي والموشن جرافيك مع خبرة 12 عاماً في المجال'
    },
    {
      name: 'خالد سعد المطيري',
      position: 'مدير التصوير والإخراج',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Saudi%20Arabian%20male%20cinematographer%20with%20camera%20equipment%2C%20creative%20and%20artistic%20pose%2C%20film%20studio%20background%20with%20professional%20lighting%20and%20video%20production%20setup&width=300&height=400&seq=8&orientation=portrait',
      bio: 'مخرج ومصور محترف حاصل على عدة جوائز في مهرجانات الأفلام المحلية والإقليمية'
    },
    {
      name: 'نورا حسن الزهراني',
      position: 'مديرة التسويق والعلاقات العامة',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Saudi%20Arabian%20female%20marketing%20director%20in%20elegant%20business%20attire%2C%20confident%20and%20approachable%20pose%2C%20modern%20office%20environment%20with%20marketing%20materials%20and%20digital%20displays&width=300&height=400&seq=9&orientation=portrait',
      bio: 'خبيرة في التسويق الرقمي والعلاقات العامة مع خبرة 10 سنوات في القطاع الإعلامي'
    }
  ];

  const values = [
    {
      icon: 'ri-heart-line',
      title: 'الشغف',
      description: 'نحن شغوفون بما نقوم به ونؤمن بقوة الإعلام في تشكيل الواقع وإلهام الناس'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'الأمانة',
      description: 'نلتزم بالصدق والشفافية في جميع تعاملاتنا مع عملائنا وشركائنا'
    },
    {
      icon: 'ri-rocket-line',
      title: 'الابتكار',
      description: 'نسعى دائماً للابتكار والتطوير لنقدم حلولاً إبداعية تواكب العصر'
    },
    {
      icon: 'ri-team-line',
      title: 'العمل الجماعي',
      description: 'نؤمن بقوة العمل الجماعي والتعاون لتحقيق أفضل النتائج'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'رضا العميل',
      description: 'رضا عملائنا هو هدفنا الأول ونسعى لتجاوز توقعاتهم في كل مشروع'
    },
    {
      icon: 'ri-global-line',
      title: 'الرؤية العالمية',
      description: 'نطمح لأن نكون علامة فارقة في صناعة الإعلام على المستوى الإقليمي والعالمي'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative pt-20 pb-32 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://readdy.ai/api/search-image?query=Professional%20media%20production%20team%20working%20together%20in%20modern%20studio%20with%20cameras%2C%20lighting%20equipment%2C%20and%20creative%20workspace%20showcasing%20collaboration%20and%20teamwork%20in%20Saudi%20Arabian%20media%20industry&width=1920&height=1080&seq=10&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">من نحن</h1>
          <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed">
            نحن فريق من المبدعين والمحترفين الذين يؤمنون بقوة الإعلام في تشكيل المستقبل
          </p>
        </div>
      </section>

      {/* Vision, Mission, Goals */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="text-center group">
              <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-eye-line text-3xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">رؤيتنا</h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                أن نكون الشركة الرائدة في مجال الإنتاج الإعلامي في المملكة العربية السعودية والمنطقة، 
                ونساهم في تطوير صناعة الإعلام المحلي وتقديم محتوى إبداعي يعكس هويتنا وثقافتنا.
              </p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-compass-line text-3xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">رسالتنا</h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                نلتزم بتقديم خدمات إنتاج إعلامي متميزة تجمع بين الإبداع والتقنية والاحتراف، 
                ونساعد عملاءنا على إيصال رسائلهم بطريقة مؤثرة وفعالة تحقق أهدافهم التجارية والتسويقية.
              </p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-target-line text-3xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">أهدافنا</h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                نسعى لتطوير صناعة الإنتاج الإعلامي محلياً، وتدريب الكوادر الشابة، 
                والاستثمار في أحدث التقنيات لنقدم خدمات تنافس المعايير العالمية وتلبي احتياجات السوق المحلي.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Timeline */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">تاريخنا وإنجازاتنا</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              رحلة نمو وتطور مستمر منذ التأسيس حتى اليوم
            </p>
          </div>
          
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-yellow-500"></div>
            
            {timeline.map((item, index) => (
              <div key={index} className={`relative flex items-center mb-12 ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                <div className={`w-full md:w-5/12 ${index % 2 === 0 ? 'md:pr-8' : 'md:pl-8'}`}>
                  <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 hover:shadow-2xl transition-shadow duration-300">
                    <div className="text-2xl font-bold text-yellow-600 mb-2">{item.year}</div>
                    <h3 className="text-xl font-bold text-gray-900 mb-4">{item.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{item.description}</p>
                  </div>
                </div>
                
                <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-yellow-500 rounded-full border-4 border-white shadow-lg"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">فريق العمل</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              تعرف على الفريق المبدع الذي يقف وراء نجاح مشاريعنا
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
                <div className="relative overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
                  <p className="text-yellow-600 font-medium mb-4">{member.position}</p>
                  <p className="text-gray-600 text-sm leading-relaxed">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">قيمنا ومبادئنا</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              القيم التي نؤمن بها وتوجه عملنا في كل مشروع نقوم به
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center group">
                <div className="w-20 h-20 bg-gradient-to-r from-yellow-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${value.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold mb-4">{value.title}</h3>
                <p className="text-gray-300 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-20 bg-gradient-to-r from-yellow-600 to-red-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-4xl mx-auto">
            <div className="text-6xl mb-8 opacity-50">
              <i className="ri-double-quotes-l"></i>
            </div>
            <blockquote className="text-2xl md:text-3xl font-bold mb-8 leading-relaxed" style={{ fontFamily: 'serif' }}>
              نحن لا نصنع مجرد محتوى إعلامي، بل نصنع قصصاً تلهم وتؤثر وتترك أثراً إيجابياً في المجتمع
            </blockquote>
            <cite className="text-xl font-medium">
              - أحمد محمد الأحمد، المدير التنفيذي والمؤسس
            </cite>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
}
